<template>
  <div class="full-page">
    <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
      <div class="page-content">
       <DetailInfo :title="title" :tag="choiceTypeText" :endTime="endTime" :description="content" />
        <div class="check-box" v-if="resultStatistic">
         <van-cell-group>
           <van-cell v-for="(item, index) in resultStatistic" :key="index">
            <template #title>
              <span class="option-name">{{item.optionName}}</span>
            </template>
            <template #default>
              <span class="option-count">{{item.count}}票</span>
              <span class="option-percent">{{handlePercent(item.proportion)}}%</span>
            </template>
           </van-cell>
         </van-cell-group>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { voteRecordDetailAPI } from "@/api/vote";
import { checkResponse } from "@/assets/js/utils";
import DetailInfo from '@/components/DetailInfo'
export default {
  name: "VoteRecordDetail",
  components: {DetailInfo},
  data() {
    return {
      detailId: 0,
      isRefresh: false,
      title: "",
      content: "",
      endTime: undefined,
      choiceType: undefined, //0-单选 1多选
      resultStatistic: undefined,
    };
  },
  computed: {
    choiceTypeText() {
      return this.choiceType != undefined
        ? this.choiceType === 0
          ? "单选"
          : "多选"
        : "";
    },
  },
  mounted() {
    BridgeNativeMethods.setTitle("投票");
  
    this.detailId = this.$route.params.id;
    this.requestData();
  },
  methods: {
    requestData() {
      BridgeNativeMethods.showLoading();
      voteRecordDetailAPI(this.detailId).then(
        (response) => {
          if (this.isRefresh) this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          if (checkResponse(response)) {
            let { title, endTime, resultStatistic, choiceType,content } = response.data;
            this.choiceType = choiceType;
            this.endTime = endTime;
            this.title = title;
            this.content = content;
            this.resultStatistic = resultStatistic;
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          if (this.isRefresh) this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          BridgeNativeMethods.showToast("请求错误");
          console.log("activity detail err", err);
        }
      );
    },
    handlePercent(value) {
      let percent = value.slice(0,value.length-1)
      if(percent === '0') {
        return percent
      } else {
        return parseFloat(parseFloat(percent).toFixed(2))
      }
      
    },
    onRefresh() {
      this.isRefresh = true;
      this.requestData();
    },
  },
};
</script>

<style lang="less" scoped>
.page-content {
  min-height: 80vh;
}
.info {
  background-color: #fff;
  padding: 16px;
}
.title {
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
  vertical-align: middle;
}
.tag {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0 4px;
  background: @theme-orange;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  margin-left: 8px;
}
.time {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 8px;
}
.check-box {
  background-color: #fff;
  margin-top: 21px;
  margin-bottom: 21px;
}
.option{
  &-name {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }

  &-count,&-percent {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    display: inline-block;
   
  }
  &-percent{
    width: 65px;
     text-align: right;
  }
}
/deep/.van-cell::after{
  right:0;
}
</style>